import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Toolbar,
  Badge,
  IconButton,
  Divider,
  MenuItem,
  Drawer,
} from '@mui/material';
import { 
  Circle, 
  PowerOff, 
  Notifications,
} from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import {Link } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {SilverButton, ActiveSilverButton} from '../utils/constants';

// 移动端专用顶部工具栏组件
export const MobileChatToolbar = ({
  isConnected,
  isConnecting,
  disconnectReason,
  onConnect,
  onDisconnect,
  notifications,
  onShowNotifications,
  onlineCount,
  isAuthenticated,
}) => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  return (
    <Paper
      sx={{
        backgroundColor: isConnected 
          ? 'rgba(0,0,0,0.8)' 
          : 'rgba(255,255,255,0.95)',
        border: `1px solid ${isConnected ? 'rgba(255,0,0,0.3)' : 'rgba(0,0,0,0.1)'}`,
        color: isConnected ? 'white' : 'inherit',
        mb: 1,
      }}
    >
      <Toolbar variant="dense" sx={{ justifyContent: 'space-between', minHeight: 48 }}>
        {/* 左侧状态信息 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
          {!isConnected && !isConnecting && !disconnectReason && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: isConnected ? 'rgba(255,255,255,0.8)' : 'text.secondary',
                fontSize: '0.8rem'
              }}
            >
              點擊連接開始聊天
            </Typography>
          )}
          
          {isConnecting && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} />
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'warning.main',
                  fontSize: '0.8rem'
                }}
              >
                連線中...
              </Typography>
            </Box>
          )}
          
          {disconnectReason && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'error.main',
                fontSize: '0.8rem'
              }}
            >
              {disconnectReason}
            </Typography>
          )}
          
          {isConnected && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Circle sx={{ fontSize: 12, color: 'success.main' }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: '0.8rem'
                }}
              >
                已連線 {onlineCount}人
              </Typography>
            </Box>
          )}
        </Box>

        {/* 右侧按钮组 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* 通知按钮 - 仅连接时显示 */}
          {isConnected && (
            <IconButton
              size="small"
              onClick={onShowNotifications}
              sx={{
                color: isConnected ? 'rgba(255,255,255,0.8)' : 'inherit',
                '&:hover': {
                  backgroundColor: 'rgba(255,152,0,0.2)',
                }
              }}
            >
              <Badge badgeContent={notifications.length} color="error">
                <Notifications fontSize="small" />
              </Badge>
            </IconButton>
          )}
          
          {/* 连接/断开按钮 */}
          {!isConnected ? (
            <Button
              variant="contained"
              size="small"
              onClick={onConnect}
              disabled={isConnecting}
              startIcon={isConnecting ? <CircularProgress size={12} /> : <Circle />}
              sx={{
                minWidth: 60,
                fontSize: '0.75rem'
              }}
            >
              {isConnecting ? '連線中' : '連接'}
            </Button>
          ) : (
            <Button
              variant="outlined"
              size="small"
              onClick={onDisconnect}
              startIcon={<PowerOff />}
              sx={{
                color: 'rgba(255,255,255,0.8)',
                borderColor: 'rgba(255,255,255,0.3)',
                '&:hover': {
                  backgroundColor: 'rgba(255,0,0,0.1)',
                  borderColor: 'rgba(255,0,0,0.5)',
                },
                minWidth: 60,
                fontSize: '0.75rem'
              }}
            >
              斷開
            </Button>
          )}
          {/* 手機端 */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{ sx: { top: 'var(--template-frame-height, 0px)' } }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton onClick={toggleDrawer(false)}><CloseRoundedIcon /></IconButton>
                </Box>

                {/* 手機端導航 */}
                <Link to="/news">{location.pathname === '/news' ? <ActiveSilverButton>財經新聞</ActiveSilverButton> : <SilverButton>財經新聞</SilverButton>}</Link>
                <Link to="/chart">{location.pathname === '/chart' ? <ActiveSilverButton>金融圖表</ActiveSilverButton> : <SilverButton>金融圖表</SilverButton>}</Link>
                <Link to="/waroom">{location.pathname === '/waroom' ? <ActiveSilverButton>政經戰情室</ActiveSilverButton> : <SilverButton>政經戰情室</SilverButton>}</Link>
                <Link to="/institute">{location.pathname === '/institute' ? <ActiveSilverButton>無政府主義研究院</ActiveSilverButton> : <SilverButton>無政府主義研究院</SilverButton>}</Link>
                <Link to="/declaration">{location.pathname === '/declaration' ? <ActiveSilverButton>聲明</ActiveSilverButton> : <SilverButton>聲明</SilverButton>}</Link>
                
                <Divider sx={{ my: 3 }} />

                {/* ✅ 手機端：依據登入狀態切換 */}
                {isAuthenticated ? (
                  <Link to="/dashboard"><Button color="primary" variant="text">個人中心</Button></Link>
                ) : (
                  <>
                    <MenuItem><Link to="/signup"><Button color="primary" variant="contained" fullWidth>註冊</Button></Link></MenuItem>
                    <MenuItem><Link to="/signin"><Button color="primary" variant="outlined" fullWidth>登入</Button></Link></MenuItem>
                  </>
                )}
              </Box>
            </Drawer>
          </Box>
        </Box>
      </Toolbar>
    </Paper>
  );
};
